import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/sizes`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getAll({commit}, payload?: { provider?: string }) {
    return axiosInstance.get(baseUrl, {
      params: payload || {},
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
